import { Modal, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ModalPopupTypes {
  open: boolean;
  handleClose: () => void;
  children: React.ReactNode;
  heading: String
}
const ModalPopup: React.FC<ModalPopupTypes> = ({ open, handleClose, children, heading }) => {

  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Box className="modalCutomFields manageCutomFields">
          <div className="modalHeading modalHeadingBetween">
            <h3>{heading}</h3>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                color: 'grey.500',
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="bodyModalCheck">
          <Typography sx={{ mt: 2 }}>
            {children}
          </Typography>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default ModalPopup;